import { createFileRoute } from "@tanstack/react-router";

/** Every pod on the floor, none open. The page is `pods.tsx`'s; this names the
 *  selection only. */
export const Route = createFileRoute("/_console/production/pods/")({
  component: () => null,
});
